import {
  Box,
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

interface PageSizeSelectProps {
  pageSize: number;
  pageSizeOptions: number[];
  onPageSizeChange?: (size: number) => void;
}

const PageSizeSelect = ({
  pageSize,
  pageSizeOptions,
  onPageSizeChange,
}: PageSizeSelectProps) => {
  const handlePageSizeChange = (event: SelectChangeEvent<number>): void => {
    onPageSizeChange?.(Number(event.target.value));
  };

  return (
    <FormControl
      className="pageSizeSelector"
      variant="outlined"
      sx={{
        width: 170,
        flexShrink: 0,

        "& .MuiOutlinedInput-root": {
          height: "auto",
          borderRadius: 0,
          border: "none",
          backgroundColor: "#F1F2F3",
        },

        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "none",
        },

        "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: "none",
        },

        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
          {
            borderColor: "none",
          },

        "& .MuiSelect-select": {
          display: "flex",
          alignItems: "center",
          boxSizing: "border-box",
          height: "68px",
          padding: "7px 48px 7px 12px",
        },

        "& .MuiSelect-icon": {
          right: 18,
          top: "50%",
          color: "#5F666C",
          fontSize: 30,
          transform: "translateY(-50%)",
          transition: "transform 150ms ease",
        },

        "& .MuiSelect-iconOpen": {
          transform: "translateY(-50%) rotate(180deg)",
        },
      }}
    >
      <Select<number>
        value={pageSize}
        onChange={handlePageSizeChange}
        IconComponent={KeyboardArrowDownIcon}
        sx={{
          borderRadius: 0,
          outline: "none",

          "& .MuiOutlinedInput-notchedOutline": {
            border: "none !important",
          },

          "&:hover .MuiOutlinedInput-notchedOutline": {
            border: "none !important",
          },

          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            border: "none !important",
          },

          "&:focus": {
            outline: "none",
          },
        }}
        renderValue={(selectedPageSize) => (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              lineHeight: 1.1,
            }}
          >
            <Box
              component="span"
              sx={{
                marginBottom: "4px",
                color: "#161A1D",
                fontSize: "10px",
                fontFamily: "Bosch Sans",
                fontWeight: 600,
                whiteSpace: "nowrap",
              }}
            >
              Itens por página
            </Box>

            <Box
              component="span"
              sx={{
                color: "#33383D",
                fontSize: "14px",
                fontWeight: 400,
              }}
            >
              {selectedPageSize}
            </Box>
          </Box>
        )}
        MenuProps={{
          anchorOrigin: {
            vertical: "top",
            horizontal: "left",
          },
          transformOrigin: {
            vertical: "bottom",
            horizontal: "left",
          },
          marginThreshold: 0,
          disableScrollLock: true,
          PaperProps: {
            sx: {
              maxHeight: 460,
              borderRadius: 0,
              boxShadow: "0 2px 12px rgba(0, 0, 0, 0.25)",

              "& .MuiList-root": {
                padding: 0,
              },

              "& .MuiMenuItem-root": {
                minHeight: 54,
                padding: "0 24px",
                color: "#252A2E",
                fontSize: "14px",
                backgroundColor: "#FFFFFF",
              },

              "& .MuiMenuItem-root:hover": {
                backgroundColor: "#EAF4FB",
              },

              "& .MuiMenuItem-root.Mui-selected": {
                color: "#FFFFFF",
                fontWeight: 500,
                backgroundColor: "#0087C9",
              },

              "& .MuiMenuItem-root.Mui-selected:hover": {
                backgroundColor: "#007BC0",
              },
            },
          },
        }}
      >
        {pageSizeOptions.map((size) => (
          <MenuItem key={size} value={size}>
            {size}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default PageSizeSelect;
